export default __webpack_public_path__ + "static/footer-img-d9f1eff1c546294556b2b5513b34f5b0.jpg";